export enum ContentType {
    Image = 'image',
    Wysiwyg = 'wysiwyg',
    PageSlider = 'page_slider',
    NewsletterUnsubscribeForm = 'newsletter_unsubscribe_form',
    NewsletterSubscribeForm = 'newsletter_subscribe_form',
    NewsletterOptIn = 'newsletter_opt_in',
}
